<template>
  <v-dialog :value="value" max-width="912px" class="rrrr" @input="input">
    <div class="top">
      <div class="text-xs-right close">
        <a href="#" @click.prevent="$emit('closeFundModal', '')">
          <IconBase icon-name="close">
            <ClosePopupIcon />
          </IconBase>
        </a>
      </div>
      <div class="toolbar-title">
        Historic buy orders used to acquire the currently reserved
        {{
          market
            ? market.exchange +
              ":" +
              market.target_currency +
              "/" +
              market.base_currency
            : ""
        }}.
      </div>
    </div>
    <v-card class="main-card">
      <v-card-text>
        <v-data-table
          :items="orders || []"
          :headers="tableHeaders"
          :loading="loading"
          class="card-table"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>
                {{ props.item.ts_opened_utc | formatDate("DD MMM YYYY HH:mm") }}
              </td>
              <td>
                {{ props.item.ts_closed_utc | formatDate("DD MMM YYYY HH:mm") }}
              </td>
              <td>{{ props.item.price | roundCryptoPrice }}</td>
              <td>{{ props.item.quantity | roundNumber(8) }}</td>
              <td>
                <v-checkbox
                  v-model="props.item.release"
                  hide-details
                  primary
                ></v-checkbox>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-layout row wrap class="px-48 pb-40">
        <v-flex xs12 md6 lg6 class="text-xs-left">
          <p class="removed">
            <v-icon
              class="vertical-align-middle icon-for-information"
              style="font-size: 20px;"
              @click="openHelpPage"
              >fa-info-circle</v-icon
            >
            <span class="ml-3">To be removed:</span>
            <span style="font-weight: bold; margin-left: 12px;"
              >{{ total_released | roundQuantity }}
              {{ market ? market.target_currency : "" }}
            </span>
          </p>
        </v-flex>
        <v-flex xs12 md6 lg6 class="text-xs-right">
          <a href="#" class="a-btn" @click.prevent="selectDeselectAllFunds">
            <span v-if="!this.allSelected">
              Select all
            </span>
            <span v-else>
              Deselect all
            </span>
          </a>
          <a
            v-if="total_released !== 0"
            class="a-btn"
            style="margin-left: 24px;"
            href="#"
            @click.prevent="releaseFunds"
          >
            Remove selected orders
          </a>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<style scoped>
>>> th,
>>> td {
  padding-left: 0px !important;
}
.px-48 {
  padding-left: 48px;
  padding-right: 48px;
}
.pb-40 {
  padding-bottom: 40px;
}
.pb-48 {
  padding-bottom: 48px;
}
>>> .v-toolbar__content {
  height: 130px !important;
}
.card-table {
  margin-bottom: 8px;
  padding-left: 48px;
  padding-right: 48px;
}
.close {
  padding-right: 24px;
  padding-top: 24px;
}
.theme--light .top {
  background: #ffffff;
}
.theme--light .a-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  text-decoration-line: underline;
  color: #0051dd;
}
.theme--light .removed {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
>>> .theme--light .v-input--selection-controls__ripple.accent--text {
  color: #639bfb !important;
  caret-color: #639bfb !important;
}
.theme--light .toolbar-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #103a84;
  padding-left: 48px;
  padding-top: 16px;
  padding-bottom: 48px;
}

>>> .theme--light.v-table thead tr:first-child {
  border-bottom: 1px solid #e6efff;
}
>>> .theme--light.v-table tbody tr:not(:first-child) {
  border-top: 1px solid #e6efff;
}

>>> .theme--light.v-datatable .v-datatable__actions {
  border-top: 1px solid #e6efff;
}

>>> .theme--light.v-datatable .v-datatable__expand-col--expanded {
  border-bottom: 1px solid #e6efff;
}
>>> .theme--light.v-datatable thead th {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7395d0;
}
>>> .theme--light.v-datatable tbody tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}

>>> .theme--light.v-datatable tbody tr td .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}
>>> .theme--light.v-datatable thead th.column.sortable.active,
>>> .theme--light.v-datatable thead th.column.sortable.active .v-icon,
>>> .theme--light.v-datatable thead th.column.sortable:hover {
  color: #103a84;
}
>>> .theme--light .v-datatable__actions {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: #7395d0;
}
>>> .theme--light .v-datatable__actions .v-select__selections {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84 !important;
  max-height: 24px;
}

>>> .theme--light
  .v-datatable__actions
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84;
  padding-left: 8px;
}

>>> .theme--light .v-datatable__actions .v-input__slot {
  border: 0.8px solid #103a84;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 24px;
}

>>> .v-datatable__actions
  .v-text-field
  > .v-input__control
  > .v-input__slot::after,
>>> .v-datatable__actions
  .v-text-field
  > .v-input__control
  > .v-input__slot::before {
  width: 0px;
}
>>> .theme--light .v-datatable__actions .v-btn {
  color: #103a84;
}
>>> .theme--light.v-btn.v-btn--disabled,
>>> .theme--light.v-btn.v-btn--disabled .v-btn__loading,
>>> .theme--light.v-btn.v-btn--disabled .v-icon {
  color: #b8d2ff !important;
}

>>> .v-datatable__actions .theme--light.v-icon {
  color: #103a84 !important;
}

>>> .v-datatable__actions .v-input__append-inner {
  margin-top: 0px !important;
}

/**********************************/

>>> .theme--dark.v-table {
  background: #212121;
}
>>> .theme--dark.v-datatable .v-datatable__actions {
  background: #212121;
}
>>> .theme--dark.v-datatable thead th {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark.v-datatable tbody tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #e9e9e9;
}
>>> .theme--dark.v-datatable tbody tr td .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
}
>>> .theme--dark.v-datatable thead th.column.sortable.active,
>>> .theme--dark.v-datatable thead th.column.sortable.active .v-icon,
>>> .theme--dark.v-datatable thead th.column.sortable:hover {
  color: #ffffff;
}
>>> .theme--dark .v-datatable__actions {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark .v-datatable__actions .v-select__selections {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  max-height: 24px;
  color: rgba(235, 235, 245, 0.6);
}

>>> .theme--dark
  .v-datatable__actions
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-left: 8px;
  color: #ffffff;
}

>>> .theme--dark .v-datatable__actions .v-input__slot {
  border: 0.8px solid #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 24px;
}
>>> .v-datatable__actions .theme--dark.v-icon {
  color: #ffffff !important;
}
>>> .theme--dark.v-btn.v-btn--disabled,
>>> .theme--dark.v-btn.v-btn--disabled .v-btn__loading,
>>> .theme--dark.v-btn.v-btn--disabled .v-icon {
  color: rgba(235, 235, 245, 0.6) !important;
}

.theme--dark .main-card {
  background: #212121;
}
.theme--dark .a-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  text-decoration-line: underline;
  color: #639bfb;
}
.theme--dark .removed {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #e9e9e9;
}
.theme--dark .toolbar-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #e9e9e9;
  padding-left: 48px;
  padding-top: 16px;
  padding-bottom: 48px;
}
.theme--dark .top {
  background: #212121;
}
>>> .theme--dark .v-input--selection-controls__ripple.accent--text {
  color: #639bfb !important;
  caret-color: #639bfb !important;
}
@media (max-width: 600px) {
  .card-table {
    margin-bottom: 8px;
    padding-left: 0px;
    padding-right: 0px;
  }
  .toolbar-title {
    padding-left: 16px !important;
  }
}
</style>

<script>
import axios from "axios";
import swal from "sweetalert2";
import { bugsnagClient } from "~/plugins";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import { mapGetters } from "vuex";
import IconBase from "../icons/IconBase";
import ClosePopupIcon from "../icons/ClosePopupIcon";

const timezone = moment()
  .tz(moment.tz.guess())
  .format("z");

export default {
  components: {
    IconBase,
    ClosePopupIcon
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    market: {}
  },
  data: function() {
    return {
      allSelected: false,
      tableHeaders: [
        {
          text: `Opened time (${timezone})`,
          value: "ts_opened_utc"
        },
        {
          text: `Closed time (${timezone})`,
          value: "ts_closed_utc"
        },
        {
          text: "Price",
          value: "price"
        },
        {
          text: "Quantity",
          value: "quantity"
        },
        {
          text: "Remove",
          value: null,
          sortable: false
        }
      ],
      orders: null,
      release_checkboxes: [],
      loading: true
    };
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode"
    }),
    total: function() {
      if (this.orders) {
        return this.orders.reduce((total, order) => {
          return total + order.quantity;
        }, 0);
      }

      return 0;
    },
    total_released: function() {
      if (this.orders) {
        return this.orders
          .filter(order => order.release)
          .reduce((total, order) => {
            return total + order.quantity;
          }, 0);
      }

      return 0;
    }
  },
  watch: {
    market: function(newMarket, oldMarket) {
      this.loadOrders(newMarket);
      this.allSelected = false;
    }
  },
  methods: {
    openHelpPage: () => {
      const url = "https://help.gsmg.io/en/articles/2506867-release-funds";
      window.open(url, "_blank");
    },
    loadOrders: async function(market) {
      this.loading = true;
      this.orders = null;

      if (market === null) {
        return;
      }

      try {
        const response = await axios.get(
          "/api/v1/markets/" + market.name + "/reserved-buy-orders"
        );

        this.orders = response.data;
        this.loading = false;
      } catch (error) {
        await swal({
          title: "Problem getting buy orders",
          showConfirmButton: false,
          showCloseButton: true,
          customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
          imageUrl: "/img/popup_img_error.png",
          imageHeight: 80,
          imageWidth: 80
        });

        bugsnagClient.notify(error);
      }
    },
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    },
    input(newval) {
      this.$emit("input", newval);
    },
    sendRequest: async function(order_ids) {
      try {
        await axios.post(
          "/api/v1/markets/" + this.market.name + "/release-buy-orders",
          {
            order_ids: order_ids
          }
        );

        this.$emit("input", false);
      } catch (error) {
        let reason;
        if (error.response.data.toString()) {
          reason = error.response.data.toString();
        } else {
          reason = "Please try again later.";
        }

        await swal({
          title: "Problem releasing funds",
          html: reason,
          showConfirmButton: false,
          showCloseButton: true,
          customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
          imageUrl: "/img/popup_img_error.png",
          imageHeight: 80,
          imageWidth: 80
        });

        bugsnagClient.notify(error);
      }
    },
    selectDeselectAllFunds: async function() {
      for (let order of this.orders) {
        order.release = !this.allSelected;
      }

      this.allSelected = !this.allSelected;
    },
    releaseFunds: async function() {
      const order_ids = this.orders
        .filter(order => order.release)
        .map(order => order.id);

      if (!order_ids || order_ids.length === 0) {
        await swal({
          title:
            "No orders have been selected, please select one or more orders to release.",
          showCloseButton: true,
          customClass: this.themeDark ? "swal-type-warning-dark" : "swal-type-warning",
          imageUrl: "/img/popup_img_warning.png",
          imageHeight: 48,
          imageWidth: 48
        });

        return;
      }

      let confirm = await swal({
        title: "Warning",
        html: `<p>Please conform that you want to release ${this.$options.filters.roundQuantity(
          this.total_released
        )} ${this.market.target_currency} from ${
          this.market.name
        }.</p><p>Are you sure?</p><p>It may take up to 30 minutes before the orders are released.</p>`,
        showCancelButton: true,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-warning-dark" : "swal-type-warning",
        imageUrl: "/img/popup_img_warning.png",
        imageHeight: 48,
        imageWidth: 48
      });

      if (confirm.dismiss) {
        // bail
        return false;
      }

      this.sendRequest(order_ids);
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/dashboard/MarketReleaseFundsDialog.vue